export default __webpack_public_path__ + "static/media/photo2.dadcd710.jpg";